<template>
  <div :class="bem()">
    <!-- Label -->
    <BodyCopy :class="bem('label')">
      Interest Level:
    </BodyCopy>

    <!-- Radio group of each available level -->
    <div :class="bem('levels')">
      <div
        v-for="level in levels"
        :key="level"
        :class="bem('level', {
          disabled,
          selected: level === modelValue,
          wasSelected: level === previouslySelected,
          notSelected: modelValue && level !== modelValue
        })"
        @click.stop="handleInput(level)"
      >
        <input
          :id="level"
          type="radio"
          :value="level"
          :checked="level === modelValue"
          :class="bem('level-input')"
          @input="handleInput($event.target.value)"
        >
        <label
          :for="level"
          :class="bem('level-label')"
        >
          {{ level }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvestLevelSelect',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup () {
    const bem = useBEM('InvestLevelSelect')
    return { bem }
  },
  data: () => ({
    levels: [
      '£25 - £100',
      '£100 - £500',
      '£500 - £1k',
      '£1k - £5k',
      '£5k - £10k',
      '£10k - £20k',
      '£20k - £50k',
      '£50k+'
    ],
    previouslySelected: ''
  }),
  methods: {
    handleInput (level) {
      if (this.modelValue && this.modelValue !== level) this.previouslySelected = this.modelValue
      const previouslySelectedValue = this.previouslySelected

      this.$emit('update:modelValue', level)

      setTimeout(() => {
        if (this.previouslySelected !== previouslySelectedValue) return
        this.previouslySelected = ''
      }, 300)
    }
  }
}
</script>

<style lang="postcss">
.InvestLevelSelect__label {
  @apply pb-xxxs;
}

.InvestLevelSelect__levels {
  @apply grid grid-cols-4 gap-xxxs;

  @screen smMax {
    @apply grid-cols-2 gap-xxs;
  }
}

.InvestLevelSelect__level-input {
  @apply opacity-0 w-0;
}

.InvestLevelSelect__level {
  @apply flex items-center justify-center
    cursor-pointer
    text-grey-800
    border border-grey-300
    bg-grey-300;
  padding: 12px 20px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;

  .InvestLevelSelect__level-label {
    @apply cursor-pointer font-bold
      whitespace-nowrap;
    transition: all 0.3s ease-in-out;
    -webkit-background-clip: text;
    background-clip: text;
    background-image: var(--gradient);
  }

  &--disabled {
    @apply transition cursor-not-allowed !opacity-50;
  }

  &:not(&--selected) {
    &:hover,
    &:hover:not(.disabled):not(:disabled),
    &:focus-within,
    &:focus-within:not(.disabled):not(:disabled) {
      @apply border-blue bg-grey-300 opacity-100;
      
      .InvestLevelSelect__level-label {
        @apply text-transparent
      }
    }
  }

  &--selected {
    color: theme('colors.white');
    background-size: 150% 100%;
    background-position: 50% 0;
    background-image: var(--gradient);
    border-color: transparent;
    transition: background-position 0.3s ease-in-out;

    .InvestLevelSelect__level-label {
      transition: none;
    }

    &:hover,
    &:hover:not(.disabled):not(:disabled) {
      background-position: 0;
      color: theme('colors.white');
    }
  }
}

/* Nesting these leads to the classes being purged for some reason */
.InvestLevelSelect__level--not-selected {
  @apply opacity-60;
}

/* Nesting these leads to the classes being purged for some reason */
.InvestLevelSelect__level--was-selected {
  /* Disable transitions when a level is unselected */
  transition: none;
  
  .InvestLevelSelect__level-label {
    transition: none;
  }
}
</style>